import { environmentVariables } from '../config/app-config/app-config.prd';
import {
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAILURE,
  USER_LOGIN_REQUEST,
  USER_LOGOUT,
  SAVE_LANGUAGE,
  SYSTEM_SELECT,
  LOAD_SALES_ORG_DETAILS,
  LOAD_ORGANIZATION_DATA_STATUS,
  SELECT_SALES_ORG,
  SHOW_HIDE_SALES_ORG_DIALOG,
  LOAD_MATERIAL_GROUP_FILTERED_DATA,
  LOAD_MATERIAL_GROUP_FILTERED_DATA_STATUS,
  LOAD_CUSTOMER_MASTER_DATA,
  CHECK_SECURE_CONNECTION,
  CHECK_SECURE_CONNECTION_STATUS,
} from '../helpers/types';

const INITIAL_STATE = {
  loggedIn: false,
  requestSubmitted: false,
  username: '',
  password: '',
  idToken: '',
  systemIP: environmentVariables.systemIP,
  client: environmentVariables.client,
  system: environmentVariables.system,
  environment: environmentVariables.environment,
  systemName: '',
  selectedSalesOrgData: {},
  customerMasterData: [],
  salesOrgData: [],
  contactPersonData: null,
  userData: {},
  materialGroupData: [],
  salesOffice: 'U311',
  salesOfficeName: 'Units Zayed City',
  isLoading: false,
  failText: '',
  isOpenSalesOrgDialog: true,
  BusinessPartner: undefined,
  isMaterialFilterDataLoading: { isLoading: false, failText: '' },
  isSecure: false,
  isSecureLoading: false,
  macAddress: null,
};

// eslint-disable-next-line no-undef

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case USER_LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: true,
        ...action.payload.authData,
        idToken: action.payload.idToken,
        salesOrgData: action.payload.data,
        selectedSalesOrgData: action.payload.data[0],
        BusinessPartner: action.payload.BusinessPartner,
        materialGroupData: action.payload.materialGroupData,
        isOpenSalesOrgDialog: action.payload.isOpenSalesOrgDialog,
        ContactPerson: action.payload.ContactPerson,
        contactPersonData: action.payload.contactPersonData,
      };
    case LOAD_MATERIAL_GROUP_FILTERED_DATA:
      return {
        ...state,
        materialGroupData: action.payload,
      };
    case CHECK_SECURE_CONNECTION:
      return {
        ...state,
        isSecure: action.payload.isSecure,
        isSecureLoading: action.payload.isSecureLoading,
        macAddress: action.payload.macAddress,
      };
    case CHECK_SECURE_CONNECTION_STATUS:
      return {
        ...state,
        isSecureLoading: action.payload,
      };
    case LOAD_MATERIAL_GROUP_FILTERED_DATA_STATUS:
      return {
        ...state,
        isMaterialFilterDataLoading: action.payload,
      };
    case SYSTEM_SELECT:
      return {
        ...state,
        systemIP: action.payload.systemIP,
        client: action.payload.client,
        system: action.payload.system,
        systemName: action.payload.systemName,
      };
    case SELECT_SALES_ORG:
      return {
        ...state,
        selectedSalesOrgData: action.payload,
      };
    case SHOW_HIDE_SALES_ORG_DIALOG:
      return {
        ...state,
        isOpenSalesOrgDialog: action.payload,
      };
    case LOAD_SALES_ORG_DETAILS:
      return {
        ...state,
        salesOrgData: action.payload,
        isLoading: false,
        failText: '',
      };
    case LOAD_CUSTOMER_MASTER_DATA:
      return {
        ...state,
        customerMasterData: action.payload,
      };
    case LOAD_ORGANIZATION_DATA_STATUS:
      return { ...state, ...action.payload };
    case USER_LOGIN_REQUEST:
      return { ...state, requestSubmitted: true };
    case USER_LOGIN_FAILURE:
    case USER_LOGOUT:
      return INITIAL_STATE;

    case SAVE_LANGUAGE:
      return {
        ...state,
        'en-AE': action.payload,
      };
    default:
      return state;
  }
};
